import { render, staticRenderFns } from "./sensor.vue?vue&type=template&id=2c03a012&"
import script from "./sensor.vue?vue&type=script&lang=js&"
export * from "./sensor.vue?vue&type=script&lang=js&"
import style0 from "./sensor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports